import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Button} from 'primeng/button';
import {Accordion, AccordionContent, AccordionHeader, AccordionPanel} from 'primeng/accordion';
import {RichResultsService} from '../../rich-results/rich-results.service';
import {buildFAQPage} from '../../rich-results/rich-results.builders';
import {RichResultsTypes} from '../../enum/rich-results-types.enum';
import {isPlatformBrowser} from '@angular/common';

export type FaqItem = {
  header: string;
  content: string;
}

@Component({
  selector: 'app-faq',
  imports: [
    Button,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent
  ],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent implements OnInit {
  protected active: string = "0";
  protected faqItems: FaqItem[] = [];
  protected readonly platformId = inject(PLATFORM_ID);

  constructor(private readonly richResultsService: RichResultsService) {
    this.faqItems = [
      {
        header: "Potrzebuję samochodu firmowego, ale nie chcę zamrażać gotówki",
        content: "Zamiast inwestować duże kwoty od razu, możesz pozyskać pojazd przez procesowe rozwiązania finansowe i licytacje Processway. Twoja firma zyskuje płynność, a Ty otrzymujesz sprawdzony samochód w atrakcyjnej cenie"
      },
      {
        header: "Obawiam się długich formalności i ukrytych kosztów",
        content: "Na platformie Processway Licytacje cała procedura jest przejrzysta, cyfrowa i zminimalizowana do kilku kroków. Widzisz warunki od razu, bez ukrytych opłat"
      },
      {
        header: "Nie mam czasu na szukanie najlepszej oferty – chcę prosty proces",
        content: "Processway zbiera w jednym miejscu szeroki wybór pojazdów z rynku poleasingowego i flotowego. Ty licytujesz online i od razu wiesz, na jakich zasadach możesz stać się właścicielem"
      },
      {
        header: "Czy rata obejmuje serwis, ubezpieczenie i opony?",
        content: "Z Processway wybierasz rozwiązania, które realnie obniżają ryzyko i koszty eksploatacji. Transparentne pakiety obsługowe zapewniają spokój i przewidywalność budżetu"
      },
      {
        header: "Zależy mi na szybkim odbiorze auta – najlepiej od ręki",
        content: "Dzięki Processway Licytacje masz dostęp do gotowych pojazdów, które możesz odebrać bez długiego oczekiwania. Całość odbywa się online – oszczędzasz czas i przyspieszasz rozwój biznesu"
      }
    ];
  }

  public ngOnInit(): void {
    this.constructFaqSchema();
  }

  private constructFaqSchema(): void {
    const faqSchema = buildFAQPage({
      mainEntity: this.faqItems.map(item => ({
        '@type': RichResultsTypes.Question,
        name: item.header,
        acceptedAnswer: {
          '@type': RichResultsTypes.Answer,
          text: item.content
        }
      }))
    });

    this.richResultsService.register(faqSchema);
  }
}
